import { Tooltip } from "@material-ui/core";
import TableComponent from "app/common/Component/Table/TableComponent";
import { formatMoney, getDateTime } from "app/common/LocalFunction";
import { VOUCHER_INVOICE_TYPE_VALUE, VOUCHER_TYPE_VALUE } from "app/common/LocalConst";
import { useStore } from "app/stores";
import { observer } from "mobx-react";
import React from "react";
import { useTranslation } from "react-i18next";

const HistoryDepositList = () => {
  const { t } = useTranslation();
  const { pageHistoryDeposit, handleChangeFormSearch, searchHistoryDeposit } =
    useStore().feeStore.historyDepositStore;
  return (
    <>
      <TableComponent
        showOrdinalNumbers
        titleNodata={t("noData")}
        data={pageHistoryDeposit?.content || []}
        // minWidth={"820px"}
        columns={[
          {
            field: "clientCard.code",
            title: t("Ngày giao dịch"),
            render: (val) => {
              return <div>{getDateTime(val?.transationDate)}</div>;
            },
          },
          {
            field: "department.name",
            title: t("Cơ sở giao dịch"),
          },
          {
            field: "price",
            title: "Người giao dịch",
            render: (val) => <span>{val?.transactionStaff?.staffName}</span>,
          },
          {
            field: "quantity",
            title: t("Nội dung giao dịch"),
            render: (data) => (
              <span className="cell-content">
                {data?.transactionType > 0 ? (
                  <>
                    {data?.voucherItem?.voucher?.note
                      ? data?.voucherItem?.voucher?.note
                      : "Cọc tiền"}
                  </>
                ) : (
                  <>
                    {data?.voucherItem?.voucher?.voucherInvoiceType === VOUCHER_INVOICE_TYPE_VALUE.Refund
                      ? "Hoàn tiền cọc"
                      : (data?.invoiceItem?.invoiceItemName || data?.voucherItem?.content)}
                  </>
                )}
              </span>
            ),
          },
          {
            field: "practitioner.staffName",
            title: t("Số tiền giao dịch"),
            align: "right",
            render: (data) => (
              <span
                className={`cell-amount ${
                  data?.transactionType > 0 ? "text-green" : "text-red"
                }`}
              >
                {data?.transactionType > 0 ? "+" : "-"}{" "}
                {formatMoney(data?.amount)}
              </span>
            ),
          },
        ]}
        dataPagination={{
          pageIndex: searchHistoryDeposit?.pageIndex,
          pageSize: searchHistoryDeposit?.pageSize,
          totalElements: pageHistoryDeposit?.totalElements,
          totalPages: pageHistoryDeposit?.totalPages,
          setPageIndex: (pageIndex) => handleChangeFormSearch({ pageIndex }),
          setPageSize: (pageSize) => handleChangeFormSearch({ pageSize }),
        }}
      />
    </>
  );
};

export default observer(HistoryDepositList);
